import { render, staticRenderFns } from "./show-descriptor-disclaimer-summary.vue?vue&type=template&id=b6dd9b9e&"
import script from "./show-descriptor-disclaimer-summary.vue?vue&type=script&lang=js&"
export * from "./show-descriptor-disclaimer-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports